<header class="shadow rounded bg-light">
  <div class="row">
    <div class="col-3">
      <img
        [ngSrc]="logo" priority
        class="img-fluid"
        alt="DEMO header logo picture"
        height="125"
        width="250"
      />
    </div>       
    <div class="col text-center">
      <br />
      <h1 class=" fw-bold"> DEMO HIPP Online Application

      </h1>
      <strong>Fill out this form and click Submit to apply.</strong>
      <p>If you prefer to download a DEMO HIPP program Application
        <a style="color: #064EBA;" lang="en" href="javascript:void(0)" 
        aria-label="download DEMO HIPP Program Application"
        (click)="openPaperApplication()">click here</a>
      </p>
    </div>
    <div class="col-3"></div>
  </div>
</header>
<br />
<main>
  <app-demoform [preference]="preference" [errorMessageIntialData]="errorMessageIntialData" [email]="email"
  [mailingAddress]="mailingAddress" [emailTo]="emailTo" [faxNo]="faxNo" [tollfreeNo]="tollfreeNo"
  [dropingAddress]="dropingAddress" [mailingOffice]="mailingOffice" [mailingAddressLine]="mailingAddressLine"
  [mailingAddressLine2]="mailingAddressLine2" [mailingCityStateZip]="mailingCityStateZip"
  [empInsuranceDataPdf]="empInsuranceDataPdf" [documentChecklistPdf]="documentChecklistPdf"
  [authorizationFormPdf]="authorizationFormPdf" [faqFormPdf]="faqFormPdf" [eobYear]="eobYear"
  [benefitYear]="benefitYear" [consentForm]="consentForm" [benefitMonth]="benefitMonth"></app-demoform>
  


</main>
<br />
<footer class=" text-center bg-light">

  <p>
    Email <a target="_blank" [href]="emailTo" alt="Email" title="email" lang="en" style="color: #064EBA;">{{email}}</a>
    |
    Fax {{faxNo}} | Phone {{tollfreeNo}} | Mail to {{mailingAddress}}
  </p>
  <div class="text-dark  p-3 bg-secondary bg-opacity-50 bg-gradient">HMS, Inc. All Rights Reserved</div>


</footer>

<demo-app-scroll-top></demo-app-scroll-top>